document.addEventListener('DOMContentLoaded',()=>{const m=document.querySelector('[data-bw-menu]'),n=document.querySelector('[data-bw-nav]');if(m&&n){
n.id=n.id||'BathwiseMobileNavigation';
m.setAttribute('type','button');
m.setAttribute('aria-controls',n.id);
const setMenu=(open,restore=false)=>{n.classList.toggle('is-open',open);n.hidden=!open;m.setAttribute('aria-expanded',String(open));m.textContent=open?'×':'☰';m.setAttribute('aria-label',open?document.body.dataset.bwCloseMenu:document.body.dataset.bwOpenMenu);document.documentElement.classList.toggle('bw-menu-open',open);if(restore)m.focus();};
setMenu(false);
m.addEventListener('click',()=>setMenu(!n.classList.contains('is-open')));
const dismissMenu=e=>{if(e.key==='Escape'&&!e.defaultPrevented&&n.classList.contains('is-open')){e.preventDefault();setMenu(false,true);}};
n.addEventListener('keydown',dismissMenu);
m.addEventListener('keydown',dismissMenu);
document.addEventListener('click',e=>{if(!n.contains(e.target)&&!m.contains(e.target))setMenu(false);});
document.addEventListener('focusin',e=>{if(!n.contains(e.target)&&!m.contains(e.target))setMenu(false);});
window.addEventListener('resize',()=>{if(getComputedStyle(m).display==='none')setMenu(false);});
}const w=document.querySelector('[data-bw-shop-wrap]'),t=document.querySelector('[data-bw-shop-toggle]');if(w&&t){w.addEventListener('pointerenter',()=>w.classList.remove('is-dismissed'));t.addEventListener('click',e=>{e.preventDefault();w.classList.remove('is-dismissed');const o=w.classList.toggle('is-open');t.setAttribute('aria-expanded',o?'true':'false')});document.addEventListener('click',e=>{if(!w.contains(e.target)){w.classList.remove('is-open');t.setAttribute('aria-expanded','false')}});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&(w.contains(document.activeElement)||w.classList.contains('is-open'))){w.classList.remove('is-open');w.classList.add('is-dismissed');t.setAttribute('aria-expanded','false');t.focus()}})}});
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-bw-hero-carousel]').forEach(carousel=>{
    const slides=[...carousel.querySelectorAll('[data-bw-hero-slide]')];
    const dots=[...carousel.querySelectorAll('[data-bw-hero-dot]')];
    const prev=carousel.querySelector('[data-bw-hero-prev]');
    const next=carousel.querySelector('[data-bw-hero-next]');
    if(slides.length<2) return;
    let current=0, timer=null;
    const show=(index)=>{
      current=(index+slides.length)%slides.length;
      slides.forEach((s,i)=>{s.classList.toggle('is-active',i===current);s.inert=i!==current;s.setAttribute('aria-hidden',i===current?'false':'true');});
      dots.forEach((d,i)=>{d.classList.toggle('is-active',i===current);d.setAttribute('aria-current',i===current?'true':'false');});
    };
    const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
    const start=()=>{
      stop();
      if(carousel.dataset.autoplay==='true'&&!carousel.contains(document.activeElement)){
        const ms=parseInt(carousel.dataset.speed||'6000',10);
        timer=setInterval(()=>show(current+1),ms);
      }
    };
    prev?.addEventListener('click',()=>{show(current-1);start();});
    next?.addEventListener('click',()=>{show(current+1);start();});
    dots.forEach(d=>d.addEventListener('click',()=>{show(parseInt(d.dataset.bwHeroDot,10));start();}));
    carousel.addEventListener('mouseenter',stop);
    carousel.addEventListener('mouseleave',start);
    carousel.addEventListener('focusin',stop);
    carousel.addEventListener('focusout',e=>{if(!carousel.contains(e.relatedTarget))start();});
    show(0);
    start();
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-bw-variant-select]').forEach(select=>{
    const info=select.closest('.bw-product-form')?.parentElement;
    const price=info?.querySelector('[data-bw-product-price]');
    const sku=info?.querySelector('[data-bw-product-sku]');
    const skuValue=sku?.querySelector('[data-bw-product-sku-value]');
    if(!price) return;
    const update=()=>{
      const opt=select.options[select.selectedIndex];
      if(opt?.dataset.price) price.textContent=opt.dataset.price;
      if(sku&&skuValue){
        skuValue.textContent=opt?.dataset.displaySku||'';
        sku.hidden=!opt?.dataset.displaySku;
      }
    };
    select.addEventListener('change',update);
    update();
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-bw-tile-calculator]').forEach(calculator=>{
    const form=calculator.closest('.bw-product-form');
    const variantSelect=form?.querySelector('[data-bw-variant-select]');
    const areaInput=calculator.querySelector('[data-bw-tile-area]');
    const wasteSelect=calculator.querySelector('[data-bw-tile-waste]');
    const result=calculator.querySelector('[data-bw-tile-result]');
    const applyButton=calculator.querySelector('[data-bw-tile-apply]');
    const quantityInput=form?.querySelector('[data-bw-product-quantity]');
    if(!areaInput||!wasteSelect||!result||!applyButton||!quantityInput) return;

    let calculatedQuantity=0;
    const number=(value)=>{
      const parsed=parseFloat(String(value||'').replace(',','.'));
      return Number.isFinite(parsed)?parsed:0;
    };
    const selectedVariant=()=>variantSelect?.options?.[variantSelect.selectedIndex]||null;
    const selectedSize=()=>selectedVariant()?.dataset.tileSize||calculator.dataset.defaultSize||'';
    const tileAreaFromSize=(size)=>{
      const values=String(size).replace(/,/g,'.').match(/\d+(?:\.\d+)?/g)||[];
      if(values.length<2) return 0;
      const width=number(values[0]);
      const height=number(values[1]);
      return width>0&&height>0?(width*height)/1000000:0;
    };
    const plural=(count,word)=>`${count} ${word}${count===1?'':'s'}`;
    const calculate=()=>{
      const area=number(areaInput.value);
      const waste=number(wasteSelect.value);
      const option=selectedVariant();
      const size=selectedSize();
      const tileArea=tileAreaFromSize(size);
      const coverage=number(option?.dataset.coveragePerBox);
      const tilesPerBox=Math.floor(number(option?.dataset.tilesPerBox));
      const sellBy=(option?.dataset.sellBy||'tile').toLowerCase();

      calculatedQuantity=0;
      applyButton.disabled=true;
      if(area<=0){
        result.textContent='Enter your area to calculate an estimated quantity.';
        return;
      }
      if(tileArea<=0&&coverage<=0){
        result.textContent='Choose a tile size before calculating the quantity.';
        return;
      }

      const totalArea=area*(1+(waste/100));
      const tiles=tileArea>0?Math.ceil(totalArea/tileArea):0;
      let summary='';

      if(coverage>0){
        const boxes=Math.ceil(totalArea/coverage);
        calculatedQuantity=boxes;
        summary=`Allow ${totalArea.toFixed(2)} m² including ${waste}% waste: ${plural(boxes,'box')} (${(boxes*coverage).toFixed(2)} m² supplied)`;
        if(tiles>0) summary+=`, approximately ${plural(tiles,'tile')}.`;
      }else if(tilesPerBox>0){
        const boxes=Math.ceil(tiles/tilesPerBox);
        calculatedQuantity=sellBy==='box'?boxes:boxes*tilesPerBox;
        summary=`Allow ${totalArea.toFixed(2)} m² including ${waste}% waste: ${plural(boxes,'box')} or ${plural(boxes*tilesPerBox,'tile')}.`;
      }else{
        calculatedQuantity=tiles;
        summary=`Allow ${totalArea.toFixed(2)} m² including ${waste}% waste: ${plural(tiles,'tile')} in ${size||'the selected size'}.`;
      }

      result.textContent=summary;
      applyButton.disabled=calculatedQuantity<1;
    };

    areaInput.addEventListener('input',calculate);
    wasteSelect.addEventListener('change',calculate);
    variantSelect?.addEventListener('change',calculate);
    applyButton.addEventListener('click',()=>{
      if(calculatedQuantity<1) return;
      quantityInput.value=String(calculatedQuantity);
      quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
      applyButton.textContent='Quantity applied';
      window.setTimeout(()=>{applyButton.textContent='Use calculated quantity';},1600);
    });
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  const definitions=[
    {key:'brand',label:'Brand',parameter:'tile_brand'},
    {key:'range',label:'Range',parameter:'tile_range'},
    {key:'effect',label:'Effect',parameter:'tile_effect'},
    {key:'material',label:'Material',parameter:'tile_material'},
    {key:'applications',label:'Suitable for',parameter:'tile_application'},
    {key:'colours',label:'Colour',parameter:'tile_colour'},
    {key:'finishes',label:'Finish',parameter:'tile_finish'},
    {key:'sizes',label:'Size',parameter:'tile_size'},
    {key:'slip',label:'Slip rating',parameter:'tile_slip_rating'},
    {key:'edge',label:'Edge',parameter:'tile_edge'},
    {key:'origin',label:'Origin',parameter:'tile_origin'}
  ];

  document.querySelectorAll('[data-bw-tile-filters]').forEach(async form=>{
    const scope=form.closest('.bw-container');
    const grid=scope?.querySelector('[data-bw-tile-product-grid]');
    let cards=[...(grid?.querySelectorAll('[data-bw-product-card]')||[])];
    const groups=form.querySelector('[data-bw-tile-filter-groups]');
    const status=form.querySelector('[data-bw-tile-filter-status]');
    const collectionCount=scope?.querySelector('[data-bw-collection-count]');
    const empty=scope?.querySelector('[data-bw-tile-filter-empty]');
    const pagination=scope?.querySelector('.bw-pagination');
    const sortForm=scope?.querySelector('.bw-sort');
    if(!grid||!groups||cards.length===0) return;
    // The fallback must cover the whole collection, never just the visible page.
    form.hidden=false;
    form.setAttribute('aria-busy','true');
    const resetButton=form.querySelector('button[type="reset"]');
    if(resetButton) resetButton.disabled=true;
    try {
      if(pagination){
        const firstUrl=new URL(window.location.href);
        firstUrl.searchParams.delete('page');
        firstUrl.searchParams.set('section_id',form.dataset.sectionId);
        const visited=new Set();
        const allCards=[];
        let nextUrl=firstUrl;
        while(nextUrl){
          if(nextUrl.origin!==window.location.origin||visited.has(nextUrl.href)) throw new Error('Invalid pagination');
          visited.add(nextUrl.href);
          if(visited.size>100) throw new Error('Collection pagination limit');
          const response=await fetch(nextUrl.href,{headers:{Accept:'text/html'},credentials:'same-origin'});
          if(!response.ok) throw new Error('Tile collection unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const pageGrid=doc.querySelector('[data-bw-tile-product-grid]');
          if(!pageGrid) throw new Error('Missing tile grid');
          allCards.push(...pageGrid.querySelectorAll('[data-bw-product-card]'));
          const next=doc.querySelector('.bw-pagination a[rel="next"]');
          nextUrl=next?new URL(next.getAttribute('href'),window.location.href):null;
          if(nextUrl) nextUrl.searchParams.set('section_id',form.dataset.sectionId);
        }
        const fragment=document.createDocumentFragment();
        allCards.forEach(card=>fragment.append(document.importNode(card,true)));
        grid.replaceChildren(fragment);
        cards=[...grid.querySelectorAll('[data-bw-product-card]')];
        pagination.hidden=true;
        document.dispatchEvent(new CustomEvent('bw:product-cards-loaded'));
      }
    } catch(error) {
      // Keep normal paging available if the complete collection cannot be loaded.
      if(status) status.textContent='Filters are temporarily unavailable. Please browse the pages below or try again.';
      form.removeAttribute('aria-busy');
      return;
    }
    form.removeAttribute('aria-busy');
    if(resetButton) resetButton.disabled=false;


    const valuesFor=(card,key)=>String(card.getAttribute(`data-filter-${key}`)||'')
      .split('||')
      .map(value=>value.trim())
      .filter(Boolean);
    const query=new URLSearchParams(window.location.search);
    const controls=new Map();

    definitions.forEach(definition=>{
      const counts=new Map();
      cards.forEach(card=>{
        valuesFor(card,definition.key).forEach(value=>counts.set(value,(counts.get(value)||0)+1));
      });
      const options=[...counts.keys()].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'}));
      if(options.length<2&&!query.has(definition.parameter)) return;

      const details=document.createElement('details');
      details.className='bw-filter';
      const summary=document.createElement('summary');
      summary.append(document.createTextNode(definition.label));
      const selectedCount=document.createElement('span');
      summary.append(selectedCount);
      const body=document.createElement('div');
      body.className='bw-filter__body';

      const checkboxes=options.map(value=>{
        const label=document.createElement('label');
        label.className='bw-filter__option';
        const input=document.createElement('input');
        input.type='checkbox';
        input.name=definition.parameter;
        input.value=value;
        input.checked=query.getAll(definition.parameter).includes(value);
        const text=document.createElement('span');
        text.textContent=value;
        const count=document.createElement('small');
        count.textContent=String(counts.get(value));
        label.append(input,text,count);
        body.append(label);
        return {input,count};
      });

      if(checkboxes.some(control=>control.input.checked)) details.open=true;
      details.append(summary,body);
      groups.append(details);
      controls.set(definition.key,{definition,details,selectedCount,checkboxes});
    });

    const selectedValues=(key)=>(controls.get(key)?.checkboxes||[])
      .filter(control=>control.input.checked)
      .map(control=>control.input.value);
    const cardMatches=(card,ignoredKey='')=>definitions.every(definition=>{
      if(definition.key===ignoredKey||!controls.has(definition.key)) return true;
      const selected=selectedValues(definition.key);
      if(selected.length===0) return true;
      const cardValues=valuesFor(card,definition.key);
      return selected.some(value=>cardValues.includes(value));
    });
    const syncSortForm=()=>{
      if(!sortForm) return;
      sortForm.querySelectorAll('[data-bw-tile-filter-state]').forEach(input=>input.remove());
      controls.forEach(({definition,checkboxes})=>{
        checkboxes.filter(control=>control.input.checked).forEach(control=>{
          const input=document.createElement('input');
          input.type='hidden';
          input.name=definition.parameter;
          input.value=control.input.value;
          input.dataset.bwTileFilterState='';
          sortForm.append(input);
        });
      });
    };
    const syncUrl=()=>{
      const url=new URL(window.location.href);
      url.searchParams.delete('page');
      definitions.forEach(definition=>url.searchParams.delete(definition.parameter));
      controls.forEach(({definition,checkboxes})=>{
        checkboxes.filter(control=>control.input.checked)
          .forEach(control=>url.searchParams.append(definition.parameter,control.input.value));
      });
      window.history.replaceState({},'',url);
    };
    const applyFilters=(updateUrl=true)=>{
      let visible=0;
      cards.forEach(card=>{
        const matches=cardMatches(card);
        card.hidden=!matches;
        if(matches) visible+=1;
      });

      controls.forEach(({definition,details,selectedCount,checkboxes})=>{
        const selected=checkboxes.filter(control=>control.input.checked).length;
        selectedCount.textContent=selected?String(selected):'';
        details.classList.toggle('has-selection',selected>0);
        checkboxes.forEach(control=>{
          const count=cards.filter(card=>cardMatches(card,definition.key)&&valuesFor(card,definition.key).includes(control.input.value)).length;
          control.count.textContent=String(count);
          control.input.disabled=count===0&&!control.input.checked;
          control.input.closest('label')?.classList.toggle('is-disabled',control.input.disabled);
        });
      });

      const noun=visible===1?'tile':'tiles';
      if(status) status.textContent=`Showing ${visible} of ${cards.length} tile ranges`;
      if(collectionCount) collectionCount.textContent=`${visible} tile ${visible===1?'range':'ranges'}`;
      if(empty) empty.hidden=visible>0;
      if(pagination) pagination.hidden=true;
      syncSortForm();
      if(updateUrl) syncUrl();
    };

    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('change',()=>applyFilters());
    form.addEventListener('reset',event=>{event.preventDefault();controls.forEach(({checkboxes})=>checkboxes.forEach(({input})=>input.checked=false));applyFilters();});
    applyFilters(false);
  });
});
